import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import SeriesCard from "@/components/feature/SeriesCard";
import { seriesList } from "@/mocks/series";

const hot = [...seriesList].sort((a, b) => b.hot - a.hot).slice(0, 8);

export default function HotSeries() {
  return (
    <section className="bg-background-100">
      <div className="mx-auto w-full max-w-[1200px] px-4 py-14 md:px-6 md:py-20">
        <SectionHeading
          eyebrow="Popular"
          title="热门剧集推荐"
          description="综合热度与评分精选的仙侠剧集，点击卡片即可查看完整剧情与角色资料。"
          action={
            <Link
              to="/category"
              className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md border border-primary-300 px-5 py-2.5 text-sm font-medium text-primary-700 transition-colors hover:bg-primary-50"
            >
              查看全部剧集
              <i className="ri-arrow-right-line"></i>
            </Link>
          }
        />
        <div className="mt-8 grid grid-cols-2 gap-3 md:grid-cols-3 md:gap-5 lg:grid-cols-4">
          {hot.map((item) => (
            <SeriesCard key={item.id} series={item} />
          ))}
        </div>
      </div>
    </section>
  );
}